export default JitsiMeetJS;
